<label (click)="isCollapsed = !isCollapsed"
  [attr.aria-expanded]="!isCollapsed" class="mt-2">
  @if (!isCollapsed) {
    <i class="fa fa-caret-down"></i>
  }
  @if (isCollapsed) {
    <i class="fa fa-caret-right"></i>
  }
  <span class="d-inline-flex p-2 h5 fw-bold">{{heading}}</span>
</label><br>
<section id="{{heading}}" [hidden]="isCollapsed">
  <ng-content></ng-content>
</section>
